export default __webpack_public_path__ + "static/media/profile.f0d2138d.webp";